import { render, staticRenderFns } from "./file-content.vue?vue&type=template&id=41d9a8e6&scoped=true"
import script from "./file-content.vue?vue&type=script&lang=js"
export * from "./file-content.vue?vue&type=script&lang=js"
import style0 from "./file-content.vue?vue&type=style&index=0&id=41d9a8e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d9a8e6",
  null
  
)

export default component.exports